var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import classnames from 'classnames';
import { defaultNumberFormat } from '../../utils';
import { useColumnAndCellSelection } from './hooks';
const getChangeElement = (change) => {
    const valueFormatted = defaultNumberFormat(change, 2);
    if (!change) {
        return React.createElement("div", { className: "number change-number" }, valueFormatted);
    }
    const isNegative = change < 0;
    const styleClass = isNegative ? 'negative-number' : 'positive-number';
    return (React.createElement("div", { className: `${styleClass} change-number` },
        React.createElement("b", null,
            !isNegative && React.createElement("span", null, "+"),
            React.createElement("span", null, valueFormatted))));
};
export const ChangeCellFormatter = React.memo((_a) => {
    var { value } = _a, props = __rest(_a, ["value"]);
    const { selectFullColumn, onSelection } = useColumnAndCellSelection(Object.assign(Object.assign({}, props), { value }));
    return (React.createElement("div", { className: classnames('grid-table-base change-formatter', {
            'cell-selected': selectFullColumn,
        }), onClick: onSelection },
        React.createElement("div", { className: "number" },
            React.createElement("span", null, defaultNumberFormat(value === null || value === void 0 ? void 0 : value.value, 2))),
        getChangeElement(value === null || value === void 0 ? void 0 : value.change)));
});
//# sourceMappingURL=ChangeFormatter.js.map